import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery, PREPAID_ENGINE_TAG_TYPES } from '../utils';
import { tariffConfigurationEndpoints } from './endpoints/tariff-configuration';
import { prepaidConfigEndPoints } from './endpoints/arrear-configuration';
import { featureConfigEndPoints } from './endpoints/feature-access-panel';
import { fppasEndpoints } from './endpoints/fppas';

export const prepaidEngineBaseQuery = customBaseQuery({
  baseUrl: `${import.meta.env.VITE_MDMS_BASE_URL}/`,
  credentials: 'same-origin',
  setHeaders: (headers) => {
    headers.set(
      'Authorization',
      `Bearer ${sessionStorage.getItem('accessToken') || ''}`
    );
    return headers;
  }
});

const prepaidEngineApi = createApi({
  reducerPath: 'prepaidEngineApi',
  baseQuery: prepaidEngineBaseQuery,
  tagTypes: PREPAID_ENGINE_TAG_TYPES,
  endpoints: (builder) => ({
    ...tariffConfigurationEndpoints(builder),
    ...prepaidConfigEndPoints(builder),
    ...featureConfigEndPoints(builder),
    ...fppasEndpoints(builder)
  })
});

export const {
  usePrefetch,
  useGetAllArrearsQuery,
  useDeleteArrearMutation,
  useUpdateArrearDataBulkMutation,
  useGetAllTarrifsQuery,
  useCreateTarrifDataMutation,
  useGetTariffByConsumerCategoryQuery,
  useGetTariffBySuppyTypeCodeQuery,
  useDeleteTariffDataMutation,
  useGetTariffDropdownsQuery,
  useUpdateTariffDataMutation,
  useGetAllFeaturesQuery,
  useCreateFeatureAccessMutation,
  useFeatureDropdownOptionsQuery,
  useGetFppasHistoryQuery,
  useCreateFppasRateMutation
} = prepaidEngineApi;

export default prepaidEngineApi;
